<template>
    <div class="ac-main">
        <van-row class="ac-main__wrapper" type="flex" align="center">
            <van-col class="ac-main__image-wrapper">
                <van-image class="ac-main__image" :src="coverPic" width="60" height="60"/>
            </van-col>
            <van-col class="ac-main__account-divider-wrapper">
                <div class="ac-main__account-divider-circle-top"><svg t="1610121744372" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1143" width="24px" height="24px"><path d="M0 512a512 512 0 1 0 1024 0Z" fill="#f2f3f5" p-id="1144"></path></svg></div>
                <div class="ac-main__account-divider-dashed"/>
                <div class="ac-main__account-divider-circle-bottom"><svg t="1610121744372" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1143" width="24px" height="24px"><path d="M0 512a512 512 0 1 1 1024 0Z" fill="#f2f3f5" p-id="1144"></path></svg></div>
            </van-col>
            <!-- 卡券信息 -->
            <van-col class="ac-main__account_info_wrapper">
                <!-- 卡券标题 -->
                <van-row>
                    <div class="ac-main__account-info-title van-ellipsis">
                        {{skuName}}
                    </div>
                </van-row>
                <!-- 卡券价格 -->
                <van-row class="ac-main__account-info-price-wrapper" type="flex" gutter="8" align="center">
                    <!-- 会员价标签 -->
                    <van-col>
                        <div class="ac-main__account-vip-tag">会员价</div>
                    </van-col>
                    <!-- 现价 -->
                    <van-col>
                        <div class="ac-main__account-price"><span class="ac-main__account-price-currency">¥</span><span>{{discPriceYuan}}</span></div>
                    </van-col>
                    <!-- 原价 -->
                    <van-col>
                        <div class="ac-main__account-raw-price" >原价 ¥ {{rawPriceYuan}}</div>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>
    </div>
</template>

<script>
import {Col, Row, Image} from "vant";

export default {
    
    name: "tic-account-card",
    components: {
        [Col.name]: Col,
        [Row.name]: Row,
        [Image.name]: Image
    },
    props: {
        coverPic: String,
        skuName: String, 
        rawPrice: Number,
        discPrice: Number
    },
    data() {
        return {};
    },
    computed: {
        rawPriceYuan: function() {
            return Math.round(this.rawPrice / 100);
        },
        discPriceYuan: function() {
            return (this.discPrice / 100).toFixed(2);
        }
    },
    methods: {
    }
}
</script>

<style lang="less">
@import "@/style/base.less";

.ac-main {
    background-color: white;
    height: 100px;
    border-radius: 8px;
    margin: 16px;
    padding: 0 8px;
}

.ac-main__wrapper {
    height: 100%;
}

.ac-main__image-wrapper {
    height: 60px;
    margin-left: 16px;
}

.ac-main__image {
}

.ac-main__account-divider-wrapper {
    margin-left: 16px;
    width: 24px;
    height: 100%;
    position: relative;
}

.ac-main__account-divider-circle-top {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 0;
    transform: translateY(-50%);
    z-index: 1;
}
.ac-main__account-divider-circle-bottom {
    z-index: 1;
    width: 24px;
    height: 24px;
    position: absolute;
    bottom: 0;
    transform: translateY(50%);
}


.ac-main__account-divider-dashed {
    z-index: -1;
    border-left: 1px dashed #0a07070f;
    height: 100%;
    transform: translateX(12px);
}
.ac-main__account_info_wrapper {
    margin-left: 16px;
}

.ac-main__account-info-title {
    font-size: @font-size-title;
    font-weight: @font-weight-title;
    color: @font-color-title;
    line-height: @line-height-title;
}

.ac-main__account-info-price-wrapper {
    margin-top: 8px;
    text-align: bottom;
}

.ac-main__account-vip-tag {
    border-radius: 2px;
    color: white;
    font-size: @font-size-mini;
    background: linear-gradient(to right, #ffd01e, #ff8917);
    padding: 2px 4px;
    font-weight: 300;
}

.ac-main__account-price {
    color: @color-theme;
    font-size: 22px;
    font-weight: @font-weight-title;
    line-height: 30px;
}

.ac-main__account-price-currency {

    font-size: @font-size-mini;
}

.ac-main__account-raw-price {
    text-decoration: line-through;
    color: @font-color-secondary;
    font-size: @font-size-mini;
}
</style>